// Framer Motion variants — reusable
export const fadeUp = {
    hidden: { opacity: 0, y: 32 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.9,
            delay: i * 0.08,
            ease: [0.22, 1, 0.36, 1],
        },
    }),
};

export const stagger = {
    hidden: {},
    show: {
        transition: { staggerChildren: 0.09, delayChildren: 0.1 },
    },
};

export const lineReveal = {
    hidden: { y: "110%" },
    show: (i = 0) => ({
        y: "0%",
        transition: {
            duration: 1.05,
            delay: 0.15 + i * 0.09,
            ease: [0.22, 1, 0.36, 1],
        },
    }),
};

export const scaleIn = {
    hidden: { opacity: 0, scale: 0.94 },
    show: {
        opacity: 1,
        scale: 1,
        transition: { duration: 1, ease: [0.22, 1, 0.36, 1] },
    },
};
